import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OnboardingService } from '../onboarding/service/onboarding.service';
import { AuthenticationService } from '../../services/authentication.service';
import { User } from '../../models/user';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LegalEntityService {
  private user: User;
  private _isAutonomo = new BehaviorSubject<number | null>(null);
  public readonly isAutonomo$: Observable<number | null> = this._isAutonomo.asObservable();

  constructor(
    private onboardingService: OnboardingService,
    private auth: AuthenticationService,
  ) {
    this.user = this.auth.currentUserValue.user;
    if (this.user && this.user.cliente) {
      this._isAutonomo.next(this.user.cliente.isAutonomo);
    }
  }

  public get currentIsAutonomo(): number | null {
    return this._isAutonomo.getValue();
  }

  public setLegalEntity(isAutonomo: number): Observable<any> {
    const legalEntityData = { 'is_autonomo': isAutonomo };
    const clienteId = this.user.cliente.id;

    return this.onboardingService.setLegalEntity(clienteId, legalEntityData).pipe(
      tap(() => {
        // Notificar a los suscriptores sobre el cambio
        this._isAutonomo.next(isAutonomo);
      })
    );
  }
}
